module.exports = __webpack_public_path__ + "static/media/cl_1.ec5481c0.jpg";